import { createContext, useContext } from 'react';
export var TooltipContext = /*#__PURE__*/createContext({});
export var useTooltipContext = function () {
  return useContext(TooltipContext);
};